module.exports = __webpack_public_path__ + "static/1 (4)-8619853f8cb9c046a26fc73f91cfa005.png";